import { Button } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'
import React, { useEffect, useState } from 'react'

const modalStyles: Record<string, number | CanvasTextAlign> = {
  fontSize: 16,
  textAlign: 'left',
}

interface FileSizeTooLargeModalProps {
  hasFileSizeError: boolean
}

const FileSizeTooLargeModal = ({
  hasFileSizeError,
}: FileSizeTooLargeModalProps) => {
  const [showFileSizeTooLargeModal, setShowFileSizeTooLargeModal] =
    useState(false)

  useEffect(() => {
    if (hasFileSizeError) {
      setShowFileSizeTooLargeModal(true)
    }
  }, [hasFileSizeError])

  function handleClose() {
    setShowFileSizeTooLargeModal(false)
  }
  return (
    <Modal
      open={showFileSizeTooLargeModal}
      onClose={handleClose}
      size="small"
      status="error"
      style={modalStyles}
    >
      <ModalTitle>Warning: Can't save playbook due to size</ModalTitle>
      <ModalBody>
        The size of this playbook is too large and cannot be saved. To reduce
        the size of this playbook, we recommend replacing repetitive bot flows
        with reusable blocks.
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClose} type={'primary'}>
          Got it
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FileSizeTooLargeModal
